export default __webpack_public_path__ + "static/media/mindmap_tdi.a78b058a.png";